import { Error } from '@material-ui/icons';
import { Snackbar } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

const ErrorText = styled.div`
  color: #ff4136;
  display: flex;
  align-items: center;
`;

const CustomError = styled(Error)`
  &&& {
    fill: #ff4136;
    margin-right: 0.5rem;
  }
`;

const ErrorNotification = ({ open, message, onCancel, onRetry }) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={open}
      onClose={onCancel}
      // autoHideDuration={3000}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
      message={
        <ErrorText id="message-id">
          <CustomError />
          {message}
        </ErrorText>
      }
    />
  );
};

export default ErrorNotification;
